import { api } from './api';
import type { Satellite, SatelliteLead, ForkSatelliteRequest } from '../types';

export const satellitesApi = {
  list: (params?: { status?: string; origin_strategy_id?: number }) => {
    const qs = new URLSearchParams();
    if (params?.status) qs.set('status', params.status);
    if (params?.origin_strategy_id) qs.set('origin_strategy_id', String(params.origin_strategy_id));
    const q = qs.toString();
    return api.get<Satellite[]>(`/satellites${q ? `?${q}` : ''}`);
  },

  get: (id: number) =>
    api.get<Satellite>(`/satellites/${id}`),

  create: (data: { name: string; origin_strategy_id: number; [key: string]: unknown }) =>
    api.post<Satellite>('/satellites', data),

  update: (id: number, data: Partial<Satellite>) =>
    api.patch<Satellite>(`/satellites/${id}`, data),

  delete: (id: number) =>
    api.delete<{ ok: boolean }>(`/satellites/${id}`),

  fork: (data: ForkSatelliteRequest) =>
    api.post<{ satellite: Satellite; strategy_id: number; brand_id: number }>('/satellites/fork', data),

  updateStatus: (id: number, status: string) =>
    api.patch<Satellite>(`/satellites/${id}/status`, { status }),

  linkAccount: (id: number, accountId: number) =>
    api.post<Satellite>(`/satellites/${id}/link-account`, { account_id: accountId }),

  getSnapshots: (id: number, days: number = 30) =>
    api.get<Record<string, unknown>[]>(`/satellites/${id}/snapshots?days=${days}`),

  listLeads: (satelliteId: number, status?: string) => {
    const qs = status ? `?status=${encodeURIComponent(status)}` : '';
    return api.get<SatelliteLead[]>(`/satellites/${satelliteId}/leads${qs}`);
  },

  addLead: (satelliteId: number, data: Partial<SatelliteLead>) =>
    api.post<SatelliteLead>(`/satellites/${satelliteId}/leads`, data),

  updateLead: (satelliteId: number, leadId: number, data: Partial<SatelliteLead>) =>
    api.patch<SatelliteLead>(`/satellites/${satelliteId}/leads/${leadId}`, data),

  promoteLead: (satelliteId: number, leadId: number) =>
    api.post<{ satellite_lead: SatelliteLead; crm_lead_id: number }>(
      `/satellites/${satelliteId}/leads/${leadId}/promote`, {}
    ),
};
